var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWeight = function SvgWeight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53856 4.48871C1.57075 4.23939 1.78305 4.05273 2.03444 4.05273H10.1077C10.3624 4.05273 10.5764 4.2442 10.6047 4.49733L11.3792 11.4446C11.4123 11.7409 11.1804 12 10.8823 12H1.13742C0.835857 12 0.602919 11.7351 0.641536 11.436L1.53856 4.48871Z",
    fill: "#2E3744",
    stroke: "#2E3744"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54223 2.52443C7.54223 3.37019 6.86323 4.04886 6.03418 4.04886C5.20512 4.04886 4.52612 3.37019 4.52612 2.52443C4.52612 1.67867 5.20512 1 6.03418 1C6.86323 1 7.54223 1.67867 7.54223 2.52443Z",
    stroke: "#2E3744"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWeight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "weight.00e75aea398f09d0254d581daf71ece0.svg";